import styled from "styled-components";
import { Accordion } from "react-bootstrap";

import borderBotomImg from "../../image/assets/border-bottom.svg";
import publicPagesBackground from "../../image/assets/public-pages-background.png";

export const StyledSection = styled.section`
  padding: 5rem 1rem;
  background: url(${publicPagesBackground}) repeat center -100%;
  @media screen and (max-width: 768px) {
    background-position: 70% 40%;
  }
  @media screen and (max-width: 425px) {
    background-position: bottom center;
  }
  @media screen and (max-width: 390px) {
    background-position: 50% 30%;
  }
  @media screen and (max-width: 375px) {
    background-position: 50% 30%;
  }
`;

export const StyledMark = styled.mark`
  color: var(--blue-color-dark);
  font-size: var(--font-size-xxl);
  background: url(${borderBotomImg}) transparent no-repeat 42% 77%;
  @media screen and (max-width: 576px) {
    font-size: var(--font-size-lg);
  }
`;

export const StyledAccordionItem = styled(Accordion.Item)`
  border: 1px solid
    ${({ $isSim }) => ($isSim ? "var(--blue-color-dark)" : "var(--primary-color)")};
  border-radius: 12px;
  color: ${({ $isSim }) => $isSim && "var(--text-color-dark)"};
  a {
    color: ${({ $isSim }) => $isSim && "var(--dark-color)"};
  }
  button.accordion-button {
    background-color: transparent;
    text-align: right;
    font-size: ${({ $isSim }) => $isSim && "var(--font-size-base)"};
    &:focus,
    &:not(.collapsed) {
      box-shadow: none;
    }
    &::after {
      position: ${({ $isSim }) => $isSim && "absolute"};
      left: ${({ $isSim }) => $isSim && "1rem"};
    }
    @media screen and (min-width: 576px) {
      font-size: ${({ $isSim }) => $isSim && "var(--font-size-lg)"};
      &::after {
        position: absolute;
        left: 1rem;
      }
    }
  }
  &:first-of-type {
    border-top-right-radius: 12px;
    border-top-left-radius: 12px;
  }
  &:last-of-type {
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
    .accordion-collapse {
      border-bottom-right-radius: 12px;
      border-bottom-left-radius: 12px;
    }
  }
`;
